<template>
  <v-container fluid class="px-0 pt-0">
    <Loading v-if="isLoading" />
    <v-row class="px-8 py-4 topBar">
      <v-col cols="3" class="pr-4 pl-3">
        <v-btn tile depressed large color="primary" class="px-0">
          <span>Total: {{ totalStudents }}</span>
        </v-btn>
      </v-col>

      <v-spacer></v-spacer>
      <v-col cols="4" class="d-flex align-center justify-end">
        <span class="mr-4">Afficher par:</span>
        <v-select
          v-model="viewMode"
          :items="listViewMode"
          hide-details
          outlined
          max-width="200"
          style="max-width: 200px"
          @change="search()"
        ></v-select>
      </v-col>

      <v-col cols="3">
        <div class="d-flex align-center justify-end">
          <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            :nudge-top="-45"
            ref="menuDateForm"
            transition="scale-transition"
            bottom
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="de"
                prepend-icon="event"
                readonly
                :value="date.from"
                v-on="on"
                clearable
                hide-details
                @click:clear="date.from = ''"
                class="mt-0"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="fr-fr"
              :min="minDate"
              :max="maxDate"
              v-model="dateFrom"
              no-title
              class="mt-0"
              @change="
                (date.from = formatDate(dateFrom)), $refs.menuDateForm.save()
              "
            ></v-date-picker>
          </v-menu>
          <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            :nudge-top="-45"
            ref="menuDateTo"
            transition="scale-transition"
            bottom
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="à"
                prepend-icon="event"
                readonly
                :value="date.to"
                v-on="on"
                clearable
                hide-details
                @click:clear="date.to = ''"
                class="mt-0"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="fr-fr"
              :min="minDate"
              :max="maxDate"
              v-model="dateTo"
              no-title
              class="mt-0"
              @change="(date.to = formatDate(dateTo)), $refs.menuDateTo.save()"
            ></v-date-picker>
          </v-menu>
          <span>
            <v-btn
              color="primary"
              style="min-width: unset;"
              @click="searchDate()"
              class="mr-0 ml-2"
            >
              <i class="fal fa-search"></i>
            </v-btn>
          </span>
        </div>
      </v-col>
    </v-row>

    <v-simple-table class="table-full table-fixed-height" :fixed-header="true">
      <thead>
        <tr>
          <th>Date</th>
          <th>Total</th>
          <th v-for="col in tableHeads" :key="col.id">
            {{ col.name }}
          </th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th v-for="col in tableHeads" :key="col.id">
            {{ totalStudentsBySourcesTransformed[col.id] ? totalStudentsBySourcesTransformed[col.id] : 0 }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in items.statisticStudents">
          <td>{{ formatDate(item.key) }}</td>
          <td>{{ totalStatistic(item.statisticSources) }}</td>
          <td v-for="mapSource in mapSources">
            {{
              item.statisticSources[mapSource.id]
                ? item.statisticSources[mapSource.id]
                : 0
            }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div class="mt-4 mb-1 mx-4" v-if="totalItems > 0">
      <div class="d-flex align-center">
        <span class="mr-4">Affichage</span>
        <v-select
          v-model="limit"
          :items="itemPerPageList"
          hide-details
          dense
          outlined
          style="max-width: 90px"
        ></v-select>
        <span class="ml-4 mr-2">sur {{ totalItems }} items par page</span>
        <v-pagination
          class="justify-start"
          v-model="page"
          :length="totalPage"
        ></v-pagination>
      </div>
    </div>

    <div class="mt-4">
      <v-row class="align-center justify-space-between px-8 py-4">
        <div class="d-flex align-center">
          <v-img
            src="assets/img/logo.png"
            width="24"
            max-width="24"
            class="mx-4"
          />
          <h2 class="font-weight-bold text-uppercase primary--text display-2">
            Leads By Source
          </h2>
        </div>
        <v-col cols="3">
          <div class="d-flex align-center justify-end">
            <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              :nudge-top="-45"
              ref="menuDateFormChart"
              transition="scale-transition"
              bottom
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="de"
                  prepend-icon="event"
                  readonly
                  :value="dateChart.from"
                  v-on="on"
                  clearable
                  hide-details
                  @click:clear="dateChart.from = ''"
                  class="mt-0"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="fr-fr"
                :min="minDate"
                :max="maxDate"
                v-model="dateChartFrom"
                no-title
                class="mt-0"
                @change="
                  (dateChart.from = formatDate(dateChartFrom)),
                    $refs.menuDateFormChart.save()
                "
              ></v-date-picker>
            </v-menu>
            <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              :nudge-top="-45"
              ref="menuDateToChart"
              transition="scale-transition"
              bottom
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="à"
                  prepend-icon="event"
                  readonly
                  :value="dateChart.to"
                  v-on="on"
                  clearable
                  hide-details
                  @click:clear="dateChart.to = ''"
                  class="mt-0"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="fr-fr"
                :min="minDate"
                :max="maxDate"
                v-model="dateChartTo"
                no-title
                class="mt-0"
                @change="
                  (dateChart.to = formatDate(dateChartTo)),
                    $refs.menuDateToChart.save()
                "
              ></v-date-picker>
            </v-menu>
            <span>
              <v-btn
                color="primary"
                style="min-width: unset;"
                @click="searchDateChart()"
                class="mr-0 ml-2"
              >
                <i class="fal fa-search"></i>
              </v-btn>
            </span>
          </div>
        </v-col>
      </v-row>

      <OptionChart height="500px" width="100%" :chart-data="lineChart" />
    </div>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import Loading from "../../components/Loading.vue";
import OptionChart from "@/components/OptionChart";

import SourceService from "../../services/source.service";
import StatisticStudentService from "../../services/statistic-student.service";

export default {
  name: "StatisticStudent",
  data: () => ({
    isLoading: false,
    page: 1,
    totalPage: 1,
    itemChart: [],
    items: [],
    limit: 50,
    totalItems: 0,
    total: 0,
    totalStudents: 0,
    tableHeads: [],
    mapSources: [],
    itemsSource: [],
    totalStudentsBySources: [],
    maxDate: new Date().toISOString().slice(0, 10),
    minDate: null,
    subDate: null,
    viewMode: "date",
    listSourceId: [],
    lineChart: {
      title: {
        show: true,
        textStyle: {
          color: "#bcbcbc"
        },
        text: "No Data",
        left: "center",
        top: "center"
      },
      tooltip: {
        //trigger: "axis",
        formatter:
          "<p style='text-align:center;margin-bottom:0px'><span style='font-size:15px;color:#333'>Matching</span> <br/><b style='color:#000;font-size:16px'>{c}</b> <br/><span style='color:#c3c2c5;text-align:center'>Leads</span></p>",
        feature: {
          dataZoom: {
            yAxisIndex: "none"
          }
        }
      },
      legend: {
        data: []
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: []
      },
      yAxis: {
        type: "value"
      },
      series: []
    },
    listViewMode: [
      {
        text: "Jour",
        value: "date"
      },
      {
        text: "Semaine",
        value: "week"
      },
      {
        text: "Mois",
        value: "month"
      },
      {
        text: "Année",
        value: "year"
      }
    ],
    dateFrom: null,
    dateTo: null,
    date: {
      from: "",
      to: ""
    },
    dateChartFrom: null,
    dateChartTo: null,
    dateChart: {
      from: "",
      to: ""
    }
  }),
  components: {
    Loading,
    OptionChart
  },
  computed: {
    ...mapState({
      itemPerPageList: state => state.pagination.itemPerPageList,
      itemPerPage: state => state.pagination.itemPerPage
    }),
    totalStudentsBySourcesTransformed() {
      if (!this.totalStudentsBySources) {
        return {};
      }

      const items = {};
      this.totalStudentsBySources.forEach(function (totalStudentsBySource) {
        items[totalStudentsBySource.sourceId] = totalStudentsBySource.total;
      });

      return items;
    }
  },

  async created() {
    this.setDateChart();
    const res = await SourceService.getList();
    this.tableHeads = res.data;
    this.mapSources = this.tableHeads;
    this.itemsSource = res.data;
    this.fetch();
    this.fetchDataChart();
  },

  methods: {
    async fetch(cb = null) {
      this.isLoading = true;
      try {
        const response = await StatisticStudentService.getPagedResult({
          page: this.page,
          limit: this.limit,
          dateFrom: this.date.from,
          dateTo: this.date.to,
          viewMode: this.viewMode
        });

        this.items = response.data.data;
        this.totalItems = response.data.total;
        this.totalPage = response.data.totalPage;
        this.totalStudents = response.data.data.totalStudents;
        this.totalStudentsBySources = response.data.data.totalStudentsBySources;

        if (typeof cb === "function") {
          cb();
        }
      } catch (e) {
        this.$notification.error(e.response.data.error.message);
      }
      this.isLoading = false;
    },

    // get data chart
    async fetchDataChart(cb = null) {
      this.isLoading = true;
      try {
        const response = await StatisticStudentService.getPagedResult({
          page: 1,
          limit: "",
          dateFrom: this.dateChart.from,
          dateTo: this.dateChart.to,
          viewMode: "date"
        });
        this.itemChart = response.data.data.statisticStudents;
        this.setLineChartSeries();
        if (typeof cb === "function") {
          cb();
        }
      } catch (e) {
        this.$notification.error(e.response.data.error.message);
      }
      this.isLoading = false;
    },

    //set data chart
    setLineChartSeries() {
      const _this = this;
      this.lineChart.legend.data = [];
      this.lineChart.series = [];
      this.lineChart.xAxis.data = [];

      // Set data xAxis
      this.itemChart.forEach((item, index) => {
        _this.lineChart.xAxis.data.push(item.key);
      });

      // Set data series
      if (this.itemChart.length > 0) {
        this.itemsSource.forEach((item, index) => {
          let data = _this.getDataChart(item.id);
          if (data.reduce((a, b) => a + b) > 0) {
            _this.lineChart.title.show = false;
            _this.lineChart.legend.data.push(item.name);
            let objChart = {
              name: item.name,
              type: "line",
              showSymbol: true,
              data: data
            };
            _this.lineChart.series.push(objChart);
          }
        });
      }
    },

    getDataChart(id) {
      let data = [];
      this.itemChart.forEach((item, index) => {
        data.push(item.statisticSources[id] ? item.statisticSources[id] : 0);
      });

      return data;
    },

    search() {
      this.page = 1;
      this.fetch();
    },
    onClientAdded(id) {
      this.fetch();
    },

    totalStatistic(item) {
      let sum = 0;
      for (const key in item) {console.log(item);
        // From 12/2025, don't include the count of source `Enquête étudiants - Master` and `Enquête étudiants - Bachelor` to the `Total`
        if (key == 34 || key == 35) {
          continue;
        }

        sum += item[key];
      }
      return sum;
    },

    searchDate() {
      this.page = 1;
      this.fetch();
    },

    searchDateChart() {
      this.page = 1;
      this.fetchDataChart();
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      let dateText = '';

      if (day) {
        dateText += `${day}/`;
      }

      if (month) {
        dateText += `${month}/`;
      }

      if (year) {
        dateText += `${year}`;
      }

      return dateText;
    },
    setDateChart() {
      let dateNow = new Date();
      dateNow.setDate(dateNow.getDate() - 7);
      this.subDate = dateNow.toISOString().slice(0, 10);

      this.dateChartFrom = this.subDate;
      this.dateChartTo = this.maxDate;
      this.dateChart.from = this.formatDate(this.subDate);
      this.dateChart.to = this.formatDate(this.maxDate);
    },
  },
  watch: {
    page(item) {
      this.page = item;
      this.fetch();
    },
    limit(item) {
      this.fetch();
    }
  }
};
</script>
